import documenti from '@/services/documentiService.js'

export const printed = async function (documentoId) {
  try {
    let documento = await documenti.getDocumento(documentoId)
    if (documento) {
      documento.editInfo = documento.editInfo || {}
      documento.editInfo.printed = documento.editInfo.printed || []
      documento.editInfo.printed.push(new Date())
      await documenti.aggiornaDocumento(documento)
    }
  } catch {
  }
}
